<template>
    <app-layout title="View SOP">
        <page-header>
            <template #title>{{ sop.title }}</template>

            <template #actions>
                <jet-tertiary-button size="small"
                    @click="openPDFPrintOut"
                >
                    <img src="/images/icons/print.svg" width="16" height="16" alt="Print" >
                </jet-tertiary-button>
                <jet-button type="button" class="leading-none" 
                    @click="$inertia.visit(`/sops/${sop.id}/edit`)"
                >
                    Edit
                </jet-button>
                <jet-tertiary-button type="button" class="leading-none"
                    @click="$inertia.visit(`/sops`)"
                >
                    Close
                </jet-tertiary-button>
            </template>
        </page-header>

        <div class="grid 2xl:grid-cols-6 md:grid-cols-4 sm:grid-cols-2 gap-x-4 gap-y-8 px-4">
            <div v-for="(step, index) in sop.sop_steps" :key="step.id">
                <div class="relative">
                    <div v-if="step.uploads.length" class="flex justify-center h-44 max-h-44 rounded-xl overflow-hidden border border-gray-200">
                        <img 
                            :src="`/storage/${step.uploads[0].path}`" 
                            class="max-h-full max-w-full block object-contain"
                        />
                    </div>

                    <div
                        class="inline-block border rounded-full bg-white py-1 px-2 text-lg leading-none font-bold"
                        :class="{'absolute top-2 left-2': step.uploads.length}"
                    >
                        {{ Number(index) + 1 }}
                    </div>
                </div>
                
                <div class="normal-lists px-3" v-html="step.description"></div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import JetButton from '@/Jetstream/Button';
import JetConfirmationModal from '@/Jetstream/ConfirmationModal';
import JetDangerButton from '@/Jetstream/DangerButton';
import JetDialogModal from '@/Jetstream/DialogModal';
import JetDropdown from '@/Jetstream/Dropdown';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import JetSecondaryButton from '@/Jetstream/SecondaryButton';

export default {
    setup() {

    },

    components: {
        AppLayout,
        PageHeader,
        JetButton,
        JetConfirmationModal,
        JetSecondaryButton,
        JetDangerButton,
        JetDialogModal,
        JetDropdown,
        JetTertiaryButton,
    },

    props: [
        'sop'
    ],

    methods:{
        openPDFPrintOut(){
            window.open(`/sops/${this.sop.id}/print`, '_blank')
        }
    }
}
</script>

<style scoped>
.step-num {
    text-shadow: -3px -3px 0 #FFF, 3px -3px 0 #FFF, -3px 3px 0 #FFF, 3px 3px 0 #FFF;
}
</style>